<template>
  <el-tabs v-model="salaryActive">
    <el-tab-pane label="公司薪酬概况" name="com">
      <pre style="white-space:pre-wrap">{{ company['薪酬/职级/奖金机制'] }}</pre>
      <div class="title" style="padding-bottom:10px;font-weight:bold">公司整体薪酬表</div>
      <div v-if="company.companyMoneyTable" class="money-table-box" style="width:100%;margin-bottom:10px">
        <NewMoneyTable v-if="company.companyMoneyTable.content" :table="company.companyMoneyTable" :hideContent="true"></NewMoneyTable>
      </div>
      <div class="title" style="padding: 10px 0;font-weight:bold">职能模块薪酬表</div>
      <div v-if="!activeCateTablCate">暂无数据</div>
      <div v-else class="money-table-box mb10" style="width:100%;height:300px">
        <el-tabs v-model="activeCateTablCate" type="card" @tab-click="chooseCate">
          <el-tab-pane v-for="(value, key) in company.categoryMoneyTable" :key="key" :label="key" :name="key">
          </el-tab-pane>
        </el-tabs>
        <NewMoneyTable v-if="activeCateTable.content" :table="activeCateTable" :hideContent="true"></NewMoneyTable>
      </div>
    </el-tab-pane>
    <el-tab-pane label="公司已有人员薪酬" name="comRadish">
      <div v-if="!company.简称">无公司</div>
      <RadishesMoney ref="RadishesMoney" v-else :companyName="company.简称"></RadishesMoney>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import NewMoneyTable from '../../../../company/src/component/NewMoneyTable'
import RadishesMoney from '../../../../radish/src/components/radishes-money'
export default {
  components: { NewMoneyTable, RadishesMoney },
  props: {
    company: { type: Object, default: () => {} },
  },
  data() {
    return {
      activeCateTable: {},
      activeCateTablCate: '',
      salaryActive: 'com',
    }
  },
  methods: {
    async initData() {
      this.activeCateTable = {}
      this.activeCateTablCate = ''
      this.salaryActive = 'com'
      this.loadMoney()
    },
    loadMoney() {
      try {
        const table = this.company.categoryMoneyTable
        if (table) {
          const cates = Object.keys(table)
          if (cates.length > 0) {
            this.activeCateTable = table[cates[0]]
            this.activeCateTablCate = cates[0]
          } else {
            this.$message('该公司暂无薪酬信息')
          }
          this.$refs.RadishesMoney && this.$refs.RadishesMoney.loadData()
        }
      } catch (e) {
        console.error(e)
      }
    },
    chooseCate(tab, event) {
      this.activeCateTable = this.company.categoryMoneyTable[tab.name]
      this.activeCateTablCate = tab.name
    },
  }
}
</script>
